import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postMakeMeTeacher() {
    const { apiPostMakeMeTeacher } = apiConfig.getStaticUrls();

    return postFetch(apiPostMakeMeTeacher);
}
